
export default function Slider1() {
	const quickCards = [
		{
			id: "arenas",
			title: "OUR ARENAS",
			desc: "Book top quality arenas near you. Anytime, anywhere.",
			link: "https://book.proplay.zone/",
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
					<rect width="20" height="14" x="2" y="5" rx="3"></rect>
					<path d="M12 5v14"></path>
					<circle cx="12" cy="12" r="3"></circle>
					<path d="M2 9h4v6H2"></path>
					<path d="M22 9h-4v6h4"></path>
				</svg>
			)
		},
		{
			id: "academies",
			title: "OUR ACADEMIES",
			desc: "Learn from expert coaches. Programs for all ages.",
			link: "/about",
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
					<path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
					<path d="M6 12v5c3 3 9 3 12 0v-5"></path>
				</svg>
			)
		},
		{
			id: "experiences",
			title: "EXPERIENCES",
			desc: "Tournaments, leagues, events and more.",
			link: "/event",
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
					<path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
					<path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
					<path d="M4 22h16"></path>
					<path d="M10 14.66V17c0 .55-.45.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
					<path d="M14 14.66V17c0 .55.45.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
					<path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
				</svg>
			)
		},
		{
			id: "membership",
			title: "MEMBERSHIP",
			desc: "Be part of a community that lives and loves sport.",
			link: "/about",
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
					<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
					<circle cx="9" cy="7" r="4"></circle>
					<path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
					<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
				</svg>
			)
		},
		{
			id: "partner",
			title: "PARTNER WITH US",
			desc: "Grow with PROPLAY. Multiple partnership opportunities.",
			link: "https://book.proplay.zone/",
			icon: (
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
					<path d="m11 17 2 2a1 1 0 0 0 1.42 0l6.58-6.59a1 1 0 0 0 0-1.41l-2.58-2.59a1 1 0 0 0-1.42 0L15 10.5"></path>
					<path d="m18 11 3-3a1 1 0 0 0 0-1.41l-2.59-2.59a1 1 0 0 0-1.41 0L14 7"></path>
					<path d="m2 14 6 6"></path>
					<path d="m7 9 5 5"></path>
					<path d="m3.5 12.5 3-3a1 1 0 0 1 1.41 0l4.59 4.59a1 1 0 0 1 0 1.41l-3 3a1 1 0 0 1-1.41 0L3.5 13.91a1 1 0 0 1 0-1.41Z"></path>
				</svg>
			)
		}
	]

	return (
		<section className="proplay-hero-section">
			{/* Background Image with Cinematic Overlay */}
			<div className="proplay-hero-bg">
				<img 
					src="images/slides/proplay-hero-banner.jpg" 
					alt="ProPlay Sports" 
					className="proplay-hero-img"
				/>
				<div className="proplay-hero-gradient-overlay" />
			</div>

			{/* Hero Main Content */}
			<div className="proplay-container proplay-hero-content-container">
				<div className="proplay-hero-content-inner">
					<div className="proplay-hero-text-block">
						<h1 className="proplay-hero-title">
							MAKE SPORT<br />
							<span className="proplay-title-blue">A WAY OF LIFE.</span>
						</h1>
						
						<p className="proplay-hero-desc">
							Discover places to play, academies to learn, communities to belong to, and sporting experiences that keep you active for life.
						</p>

						<div className="proplay-hero-cta-group">
							<a 
								href="https://book.proplay.zone/" 
								target="_blank" 
								rel="noreferrer" 
								className="proplay-btn-find-sport"
							>
								FIND YOUR SPORT
								<svg className="cta-arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
									<path d="m9 18 6-6-6-6"></path>
								</svg>
							</a>

							<a 
								href="https://book.proplay.zone/" 
								target="_blank" 
								rel="noreferrer" 
								className="proplay-btn-partner"
							>
								PARTNER WITH PROPLAY
								<svg className="cta-arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
									<path d="m9 18 6-6-6-6"></path>
								</svg>
							</a>
						</div>
					</div>
				</div>
			</div>

			{/* 5 Bottom Quick Access Feature Cards */}
			<div className="proplay-hero-cards-wrapper">
				<div className="proplay-container">
					<div className="proplay-hero-cards-grid">
						{quickCards.map((card) => (
							<a 
								key={card.id} 
								href={card.link}
								target={card.link.startsWith("http") ? "_blank" : "_self"}
								rel="noreferrer" 
								className="proplay-hero-card"
							>
								<div className="card-top-row">
									<div className="card-icon-container">
										{card.icon}
									</div>
									<div className="card-text-container">
										<h3 className="card-title-text">{card.title}</h3>
										<p className="card-desc-text">{card.desc}</p>
									</div>
								</div>
								<div className="card-arrow-row">
									<svg className="card-arrow-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
										<path d="M5 12h14"></path>
										<path d="m12 5 7 7-7 7"></path>
									</svg>
								</div>
							</a>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}
